//
import PerguntaNoPedido from '../../shared/entity/PerguntaNoPedido';
import { formatarDinheiro } from '../../shared/helper';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import colors from '../../colors';
import { TXT_P, TXT_PP } from '../../constants';

type Props = {
  pergunta: PerguntaNoPedido;
  marginLeft: number;
  quantidadeProduto: number;
};

const ItemPergunta: React.FC<Props> = (props) => {
  const { pergunta, marginLeft, quantidadeProduto } = props;
  if (!pergunta.respostasNoPedido || pergunta.respostasNoPedido.length === 0) {
    return null;
  }
  return (
    <View style={[{ marginLeft: marginLeft, marginTop: 3 }]}>
      <Text style={[styles.txtPergunta, { marginTop: 3, marginBottom: 3 }]}>
        {pergunta.descricao}
      </Text>

      <View style={{ borderLeftWidth: 2, borderColor: colors.lightGrey, marginLeft: 5 }}>
        {pergunta.respostasNoPedido.map((resposta, i) => (
          <View
            key={'resposta' + i}
            style={[styles.row, { marginLeft: 5, marginTop: 1, marginBottom: 1 }]}
          >
            <Text style={styles.txtResposta}>
              {resposta.quantidade}x {resposta.descricao}
            </Text>
            <Text style={styles.value}>
              + R$ {formatarDinheiro(resposta.preco * resposta.quantidade * quantidadeProduto)}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  txtPergunta: {
    fontSize: TXT_P,
    fontWeight: '500'
  },
  txtResposta: {
    fontSize: TXT_PP,
    fontWeight: '500'
  },
  row: { flexDirection: 'row', flex: 1, justifyContent: 'space-between', alignItems: 'center' },
  value: { color: colors.values, fontSize: TXT_PP }
});

export default ItemPergunta;
